import React from "react";
import EmptyState from "../../shared/EmptyState";

const PreferencesTab: React.FC = () => {
	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
			<EmptyState title="Preferences" description="Preferences configuration coming soon" />
		</div>
	);
};

export default PreferencesTab;
